module.exports = __webpack_public_path__ + "img/chw-logo.67d685a8.png";